const currencyFormatter = (num) => {
    if (num)
        if (num > 999 && num < 1000000) {
            return (num / 1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million 
        } else if (num > 1000000) {
            return (num / 1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million 
        } else if (num < 900) {
            return num; // if value < 1000, nothing to do
        }

    return 0
}

function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  } 

const getValue = (val, prefix = '', suffix = '') => {
    return val ? `${prefix} ${val} ${suffix}` : '-'
}

const findCreditCost = (creditCosts, requestType) => {
    if (!creditCosts) return 0;
    const costObj = creditCosts.find(cost => cost.requestType === requestType);
    return costObj ? costObj.creditCost : 0;
}

const getDocDate = (doc) => doc?.date ? new Date(doc.date) : null

const sortDocsByDate = (current, previous) => {
    const currentDate = getDocDate(current)
    const previousDate = getDocDate(previous)
    if (currentDate && previousDate && currentDate < previousDate) {
      return [current, previous]
    }
    return [previous, current]
}

export {
    currencyFormatter,
    getValue,
    findCreditCost, 
    formatPhoneNumber,
    getDocDate,
    sortDocsByDate  
}